import { RouteObject } from "react-router-dom";
import {
  PORTFOLIO_DETAILS,
  PORTFOLIO_PROJECT_CREATE,
  PORTFOLIO_PROJECT_DETAILS,
  PORTFOLIO_PROJECT_EDIT,
} from "constants/urls";

export default [
  {
    index: true,
    lazy: () => import("modules/portfolio/pages/Portfolio"),
  },
  {
    path: PORTFOLIO_DETAILS,
    lazy: () => import("modules/portfolio/pages/PortfolioDetails"),
  },
  {
    path: PORTFOLIO_PROJECT_DETAILS,
    lazy: () => import("modules/portfolio/pages/PortfolioProjectDetail"),
  },
  {
    path: PORTFOLIO_PROJECT_CREATE,
    lazy: () => import("modules/portfolio/pages/PortfolioProjectCreateEdit"),
  },
  {
    path: PORTFOLIO_PROJECT_EDIT,
    lazy: () => import("modules/portfolio/pages/PortfolioProjectCreateEdit"),
  },
] as RouteObject[];
